:host {
  font-family: var(--pl-font-family);
  font-size: var(--pl-font-size);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: var(--pl-color-bg-subtle);
  aspect-ratio: 3/2;
}

.no-image__img {
  width: 100%;
  max-width: 150px;
  filter: grayscale(1) opacity(0.3);
} 